import React, {Component} from "react";
import PageTitle from "../Components/Theme/PageTitle";
import DashboardLayout from "../Components/Theme/DashboardLayout";
import {Col, List, Row} from "antd";
import Widget from "../Components/Theme/Widget";
export default class ListPage extends Component {

    render() {
        return (
            <DashboardLayout>
                {/*** Page Title ***/}
                <PageTitle title={'About'}
                           subTitle={'STORM Mobile'}/>
                <Row gutter={32}>
                    <Col xs={24} md={12} lg={12}>
                        <Widget title={''}>
                            <ListExample1/>
                        </Widget>
                    </Col>
                </Row>
            </DashboardLayout>
        )
    }
}

export class ListExample1 extends Component {

    render() {
        const data = [
            {
                title: "STORM Mobile FAQ's",
            },
            {
                title: 'STORM Mobile Help Ticket',
            },
            {
                title: 'TimeKeeper',
            },
            {
                title: 'NBCU Production Requests (NY)',

            },
            {
                title: 'Employee User Manual',

            },
            {
                title: 'Manual de Empleado',

            },
        ];

        return (
            <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta
                            title={<span>{item.title}</span>}
                            description="Lorem Ipsum...."
                        />
                    </List.Item>
                )}
            />
        )
    }
}




// WEBPACK FOOTER //
// ./src/Pages/AboutPage.js